// Route an image through Next's built-in optimizer so we keep automatic
// resizing + avif/webp delivery even when we render a native <picture> for art
// direction (next/image cannot switch sources per media query).
//
// Widths must belong to deviceSizes/imageSizes in next.config.js — the
// optimizer rejects anything else with a 400.
export const IMAGE_QUALITY = 75;

export const optimizedSrc = (src: string, width: number) =>
    `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${IMAGE_QUALITY}`;

export const optimizedSrcSet = (src: string, widths: number[]) =>
    widths.map((w) => `${optimizedSrc(src, w)} ${w}w`).join(", ");
